module.exports = __webpack_public_path__ + "static/media/pinta-house-left.b5e4ffec.webp";